import { useQuery } from 'react-query';

import { Doc } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterDocsWithCases = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Doc[]>(
    [QueryEntity.MatterDocsWithCases, { matterId }],
    () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/docs-with-cases`, fetchConfigGET).then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, enabled: !!matterId },
  );
};
